import axios from './request';

/**
 *
 * @typedef VarrantyInfo
 * @property {string?} comment
 * @property {string?} warranty
 * @property {string?} image
 * @property {string} name
 * @property {string} producer
 * @property {string} serial
 */

/**
 *
 * @param {string} brandId
 * @param {string} serialNumber
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<import('./Response').Response<VarrantyInfo>>}
 */
export async function checkWarranty(brandId, serialNumber, config) {
	return axios.get('/api/SerialNumbers/getInfo/', {
		...config,
		params: {
			brandId: brandId,
			code: serialNumber,
		},
	})
		.then(({ data }) => data);
}
